import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { addVehicleToGroup } from '../../services/GroupsService';
import { Group, AddVehicleToGroupRequest } from '../../types/Groups';

type Result = UseMutationResult<Group, Error, AddVehicleToGroupRequest>;

function useAddVehicleToGroup(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(addVehicleToGroup, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['groups', 'vehicle', 'vehicles'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useAddVehicleToGroup;
